// extracted by mini-css-extract-plugin
export default {"zoomModal":"Q2-z"};